/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentPlanPermission
 */
export interface PaymentPlanPermission {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanPermission
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanPermission
     */
    value?: string;
}

/**
 * Check if a given object implements the PaymentPlanPermission interface.
 */
export function instanceOfPaymentPlanPermission(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentPlanPermissionFromJSON(json: any): PaymentPlanPermission {
    return PaymentPlanPermissionFromJSONTyped(json, false);
}

export function PaymentPlanPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPlanPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function PaymentPlanPermissionToJSON(value?: PaymentPlanPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

